// Ticket 12: Central debug log store with subscribers

const MAX_LOG_ENTRIES = 200;

let listeners = [];
let buffer = [];

export function debugLog(source, message, data) {
  const entry = {
    id: Date.now() + Math.random().toString(16).slice(2),
    ts: new Date().toISOString(),
    source,
    message,
    data,
  };

  buffer.push(entry);
  if (buffer.length > MAX_LOG_ENTRIES) {
    buffer = buffer.slice(buffer.length - MAX_LOG_ENTRIES);
  }

  // console.log mirror (so you still see it in DevTools)
  // eslint-disable-next-line no-console
  console.log(`[DEBUG][${source}] ${message}`, data || '');

  listeners.forEach((cb) => cb(buffer));
}

export function subscribeDebugLog(cb) {
  listeners.push(cb);
  // Initial sync
  cb(buffer);
  return () => {
    listeners = listeners.filter((l) => l !== cb);
  };
}
